import { apiClient } from './api/client';

export async function createReferral(payload) {
  return apiClient.post('/api/referrals', payload);
}

export async function createMemberThankYou(payload) {
  return apiClient.post('/api/member-thank-yous', payload);
}

export async function listReferralsReceived() {
  return apiClient.get('/api/referrals/received');
}

export async function listReferralsSent() {
  return apiClient.get('/api/referrals/sent');
}

export async function getReferralById(referralId) {
  if (!referralId) throw new Error('referralId is required');
  return apiClient.get(`/api/referrals/${encodeURIComponent(referralId)}`);
}

export async function updateReferral(referralId, patch) {
  if (!referralId) throw new Error('referralId is required');
  return apiClient.patch(`/api/referrals/${encodeURIComponent(referralId)}`, patch);
}

export async function archiveReferralForMe(referralId, { as } = {}) {
  if (!referralId) throw new Error('referralId is required');
  if (as !== 'referrer' && as !== 'receiver') {
    throw new Error("archiveReferralForMe requires as='referrer'|'receiver'");
  }

  return updateReferral(referralId, as === 'referrer'
    ? { archivedByReferrer: true }
    : { archivedByReceiver: true });
}
